import React, {Component} from 'react';
import { Layout, Spin, Table, Switch, Icon, Tag, Row, Col, Tooltip, Button, Divider, Form, Input, Modal, Select } from 'antd';
import axios from 'axios';
import Moment from 'react-moment';
import 'moment-timezone';
import { connect } from 'react-redux';
import qs from 'qs';
import jwtDecode from 'jwt-decode';

import { fetchMenuAction } from '../../store/actions/leftSideMenu';
import { Constant } from '../../config';
import MyModal from '../Modal';
import SearchForm from '../SearchForm';
import { updateProfileDetailAction } from '../../store/actions/headerBar';

const { Content } = Layout;
const ButtonGroup = Button.Group;
Moment.globalLocal = false;

class Admin extends Component {
	state = {
		loading: false,
		dataSource: [],
		visibleFormModal: false,
    current_data: {},
    flagCreateOrUpdateForm: true, // true: created, false: updated
    adminRoles: []
	}

	columns = [
    {
      title: 'ชื่อ-นามสกุล',
      dataIndex: 'firstname',
      render: (text, record)=>{
      	let lastLoginTxt = "-"
      	if (record.last_login > 0) {
      		lastLoginTxt = <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">{record.last_login}</Moment>
      	}

      	return (
      		<span>
      			<span style={{fontWeight:'bold'}}>{text} {record.lastname}</span><br />
      			<Tag color="orange">เข้าใช้งานล่าสุดเมื่อ (UTC): {lastLoginTxt}</Tag>
      		</span>
      	)
      }
    },
    {
    	title: 'อีเมล',
    	dataIndex: 'email'
    },
    {
      title: 'ตำแหน่งรับผิดชอบ',
      dataIndex: 'admin_role_id',
      render: (v) => {
        const findRole = this.state.adminRoles.find((r) => r.id === v)
        if(!findRole) {
          return '-'
        }
        return findRole['name']
      }
    },
    {
    	title: 'เปิด / ปิด',
    	dataIndex: 'is_disabled',
    	render: (text, record)=>{
        if (this._chkAdminIsMe(record.email))
          return ""

    		return (
    			<Switch
    				checkedChildren={<Icon type="check" />}
    				unCheckedChildren={<Icon type="close" />}
    				defaultChecked={!text}
    				onChange={(e)=>this.toggleStatus(e, record.id)}
    			/>
    		)
    	}
    },
    {
    	title: 'ดำเนินการ',
    	dataIndex: 'id',
    	render: (text, record)=>{
    		return (
    			<span>
	          {!record.first_active ?
	            <span>
	              <Tooltip placement="top" title="ส่งอีเมลยืนยันตัวตน">
	                <Button type="dashed" shape="circle" icon="file-sync" onClick={()=>this.reGenerate(text)} />
	              </Tooltip>
	              <Divider type="vertical" />
	            </span>
	          : ""
	          }

	          <ButtonGroup>
	            <Tooltip placement="top" title="แก้ไข">
	              <Button icon="edit" onClick={()=>this._edit(record)} />
	            </Tooltip>
	            <Tooltip placement="top" title="ลบ">
	              <Button type="danger" icon="delete" onClick={()=>this._delete(text)} />
	            </Tooltip>
	          </ButtonGroup>
	        </span>
    		)
    	}
    }
  ]
  columnsMobile = [
    {
      title: 'ชื่อ-นามสกุล',
      dataIndex: 'firstname',
      render: (text, record)=>{
        let lastLoginTxt = "-"
        if (record.last_login > 0) {
          lastLoginTxt = <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">{record.last_login}</Moment>
        }

        return (
          <span>
            <span style={{fontWeight:'bold'}}>{text} {record.lastname}</span><br />
            <Tag color="orange">เข้าใช้งานล่าสุดเมื่อ (UTC): {lastLoginTxt}</Tag>
            <Divider className="my-divider" dashed orientation="left">อีเมล</Divider>
            <div>{record.email}</div>
            <Divider className="my-divider" dashed orientation="left">ดำเนินการ</Divider>
            <Row>
              <Col span={12}>
                {!this._chkAdminIsMe(record.email) ?
                  <Switch
                    checkedChildren={<Icon type="check" />}
                    unCheckedChildren={<Icon type="close" />}
                    defaultChecked={!record.is_disabled}
                    onChange={(e)=>this.toggleStatus(e, record.id)}
                  />
                  : ""
                }
                
              </Col>
              <Col span={12}>
                {!record.first_active ?
                  <span>
                    <Tooltip placement="top" title="ส่งอีเมลยืนยันตัวตน">
                      <Button type="dashed" shape="circle" icon="file-sync" onClick={()=>this.reGenerate(record.id)} />
                    </Tooltip>
                    <Divider type="vertical" />
                  </span>
                : ""
                }

                <ButtonGroup>
                  <Tooltip placement="top" title="แก้ไข">
                    <Button icon="edit" onClick={()=>this._edit(record)} />
                  </Tooltip>
                  <Tooltip placement="top" title="ลบ">
                    <Button type="danger" icon="delete" onClick={()=>this._delete(record.id)} />
                  </Tooltip>
                </ButtonGroup>
              </Col>
            </Row>
          </span>
        )
      }
    },
  ]
  currentPage = 1
  currentSearch = ""
  limit = 10
  totalRows = 0

  componentWillMount(){
    this.props.fetchMenuAction("admin-management", "admin-management")
    this.setState({loading: true})
  }

  async componentDidMount(){
		this.setState({
			loading: false,
			dataSource: await this._getList(),
      adminRoles: await this._getAdminRoles()
		})
  }

  toggleStatus = async (f, id)=>{
  	this.setState({loading: true})

  	let url = Constant.ADMIN_DISABLE_API
  	if (f) {
  		url = Constant.ADMIN_ENABLE_API
  	}

  	let opt = {
  		url: url.replace("[id]", id),
  		method: "PUT",
  		headers: {
  			'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey)
  		}
  	}
  	let resp
    let eMsg = "เกิดข้อผิดพลาด ไม่สามารถแก้ไขข้อมูลได้ กรุณาลองใหม่อีกครั้ง"
    let eMsgDetail = ""
    let eFlag = false

    try {
      resp = await axios(opt)
    } catch(err) {
      resp = err.response
    }

    if (!resp.data) {
      eFlag = true
    } else if (resp.data.error) {
      eFlag = true
      let e = resp.data.error
      eMsgDetail = `[${e.code}] ${e.name}`
    }

    if (eFlag) {
      MyModal.error(eMsg, eMsgDetail, ()=>{
        window.location.reload()
      })
    } else {
      this.setState({loading: false})
    }
  }

  _create = () => {
  	this.setState({
      current_data: {
       id: 0,
       firstname: "",
       lastname: "",
       email: "",
      },
      flagCreateOrUpdateForm: true,
      visibleFormModal: true,
    })
  }

  _edit = (d) => {
  	this.setState({
      current_data: {
        id: d.id,
        firstname: d.firstname,
				lastname: d.lastname,
				email: d.email,
        admin_role_id: d.admin_role_id
      },
      flagCreateOrUpdateForm: false,
      visibleFormModal: true,
    })
  }

  formHandleSubmit = () => {
  	const { form } = this.formRef.props;

    form.validateFields(async (err, values) => {
      if (err)
        return

      this.setState({
        visibleFormModal: false,
        loading: true,
      })

      let url = Constant.ADMIN_API
      if (!this.state.flagCreateOrUpdateForm)
      	url = Constant.ADMIN_EDIT_API.replace("[id]", values.id)

      let opt = {
        url,
        method: (this.state.flagCreateOrUpdateForm ? "POST" : "PUT"),
        data: qs.stringify(values),
        headers: {
          'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey),
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }
      let resp
      let modeTxt = (this.state.flagCreateOrUpdateForm ? "เพิ่ม" : "แก้ไข")
      let eMsg = `เกิดข้อผิดพลาด ไม่สามารถ${modeTxt}ข้อมูลได้ กรุณาลองใหม่อีกครั้ง`
      let eMsgDetail = ""
      let eFlag = false

      try {
        resp = await axios(opt)
      } catch(err) {
        resp = err.response
      }

      if (!resp.data) {
        eFlag = true
      } else if (resp.data.error) {
        eFlag = true
        let e = resp.data.error
        eMsgDetail = `[${e.code}] ${e.name}`
      }

      if (eFlag) {
        MyModal.error(eMsg, eMsgDetail, ()=>{
          window.location.reload()
        })
      } else {
        if (this.state.flagCreateOrUpdateForm)
          form.resetFields()
        
        MyModal.info(`${modeTxt}ข้อมูลสำเร็จ`, "", async ()=>{
          this.setState({
            loading: false,
            dataSource: await this._getList(this.currentPage, this.limit, this.currentSearch)
          })

          if (!this.state.flagCreateOrUpdateForm && this.state.current_data.email === this.props.headerBarStore.profileDetail.email) {
            this.props.updateProfileDetailAction({
              firstname: values.firstname,
              lastname: values.lastname,
              email: values.email,
            })
          }
        })
      }
    });
  }

  formHandleCancel = () => {
    this.setState({visibleFormModal: false})
  }

  saveFormRef = formRef => {
    this.formRef = formRef;
  };

  reGenerate = (id) => {
  	MyModal.confirm("คุณต้องการส่งอีเมลถึงผู้ดูแลระบบอีกครั้ง ใช่หรือไม่ ?", "", async (f)=>{
      if (!f)
        return 

      let opt = {
        url: Constant.ADMIN_INVITE_AGAIN_API.replace("[id]", id),
        method: "GET",
        headers: {
          'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey)
        }
      }
      let resp
      let eMsg = `เกิดข้อผิดพลาด ไม่สามารถส่งอีเมลถึงผู้ดูแลระบบได้ กรุณาลองใหม่อีกครั้ง`
      let eMsgDetail = ""
      let eFlag = false

      try {
        resp = await axios(opt)
      } catch(err) {
        resp = err.response
      }

      if (!resp.data) {
        eFlag = true
      } else if (resp.data.error) {
        eFlag = true
        let e = resp.data.error
        eMsgDetail = `[${e.code}] ${e.name}`
      }

      if (eFlag) {
        MyModal.error(eMsg, eMsgDetail, ()=>{
          window.location.reload()
        })
      } else {
        MyModal.info("ส่งอีเมลถึงผู้ดูแลระบบสำเร็จ")
      }
    }, "ใช่", "ไม่ใช่")
  }

  _delete = (id) => {
  	MyModal.confirm("คุณต้องการลบผู้ดูแลระบบ นี้ ใช่หรือไม่ ?", "", async (f)=>{
      if (!f)
        return

      let opt = {
        url: Constant.ADMIN_EDIT_API.replace("[id]", id),
        method: "DELETE",
        headers: {
          'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey)
        }
      }
      let resp
      let modeTxt = "ลบ"
      let eMsg = `เกิดข้อผิดพลาด ไม่สามารถ${modeTxt}ผู้ดูแลระบบได้ กรุณาลองใหม่อีกครั้ง`
      let eMsgDetail = ""
      let eFlag = false

      try {
        resp = await axios(opt)
      } catch(err) {
        resp = err.response
      }

      if (!resp.data) {
        eFlag = true
      } else if (resp.data.error) {
        eFlag = true
        let e = resp.data.error
        eMsgDetail = `[${e.code}] ${e.name}`
      }

      if (eFlag) {
        MyModal.error(eMsg, eMsgDetail, ()=>{
          window.location.reload()
        })
      } else {
        MyModal.info(`${modeTxt}ผู้ดูแลระบบสำเร็จ`, "", async ()=>{
          this.setState({
            loading: false,
            dataSource: await this._getList(this.currentPage, this.limit, this.currentSearch)
          })
        })
      }
    }, "ใช่", "ไม่ใช่")
  }

  mySearch = (fd) => {
  	fd.validateFields(async (err, values)=>{
  		if (err)
  			return

      this.setState({loading: true})

	   	this.currentPage = 1
      this.currentSearch = values.searchTxt
      this.limit = 10
	    this.setState({
        dataSource: await this._getList(1, 10, this.currentSearch),
        loading: false
      })
  	})
  }

  resetSearch = async () => {
    this.setState({loading: true})
  	this.currentPage = 1
    this.currentSearch = ""
  	this.setState({
      dataSource: await this._getList(1, 10, ""),
      loading: false
    })
  }

  changePage = async (page, limit) => {
    this.setState({loading: true})
  	this.currentPage = page
  	this.limit = limit
  	this.setState({
      dataSource: await this._getList(
        page,
        limit,
        this.currentSearch,
      ),
      loading: false
    })
  }

  _getList = async (page=1, limit=10, search="")=>{
    let url = Constant.ADMIN_API+"?page="+page+"&limit="+limit+"&search="+search

    let opt = {
      url,
      method: "GET",
      headers: {
        'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey)
      },
    }
    let resp

    try {
      resp = await axios(opt)
    } catch(err) {
      resp = err.response
    }

    if (!resp.data){
      console.log(resp.data)
      return []
    }

    if (resp.data.error) {
      console.log(resp.data.error)
      return []
    }

    this.totalRows = resp.data.total_rows || 0

    return resp.data.data
  }

  _getAdminRoles = async () => {
    let url = Constant.ADMIN_ROLE_API

    let opt = {
      url,
      method: "GET",
      headers: {
        'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey)
      },
    }
    let resp

    try {
      resp = await axios(opt)
    } catch(err) {
      resp = err.response
    }

    if (!resp.data){
      console.log(resp.data)
      return []
    }

    if (resp.data.error) {
      console.log(resp.data.error)
      return []
    }
    
    return resp.data.data
  }

  _chkAdminIsMe = (email) =>{
    const token = localStorage.getItem(Constant.SessionKey)
    if (!token) {
      return true
    }
    
    let tmp

    try {
      tmp = jwtDecode(token)
    } catch (err) {
      console.log(err)
      return true
    }
    
    if (tmp.email === email)
      return true

    return false
  }

	render() {
    let propsTable = {
      className: "my-table",
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        pageSize:this.limit, 
        total:this.totalRows, 
        current:this.currentPage, 
        onChange:this.changePage, 
        size:"small"
      }
    }
    let propsTableForMobile = Object.assign({}, propsTable)
    propsTableForMobile.className = "my-table-mobile"
    propsTableForMobile.columns = this.columnsMobile

		return (
			<Layout className="my-layout">
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <Content
            style={{
              background: '#fff',
              padding: 24,
              margin: '16px 0',
              minHeight: 300,
            }}
          >
            <h2>จัดการผู้ดูแลระบบ</h2>
            <Row className="utility-bar">
              <Col span={12}><Button onClick={()=>this._create()}><Icon type="plus-circle" />เพิ่ม</Button></Col>
              <Col span={12}><SearchForm fn={this.mySearch} fnReset={this.resetSearch} /></Col>
            </Row>
            <Row className="utility-bar-mobile">
              <Button block onClick={()=>this._create()}><Icon type="plus-circle" />เพิ่ม</Button>
            </Row>
            <Row className="utility-bar-mobile">
              <SearchForm fn={this.mySearch} fnReset={this.resetSearch} />
            </Row>
            <Table {...propsTable} />
            <Table {...propsTableForMobile} />
          </Content>
        </Spin>
        <AdminForm
        	wrappedComponentRef={this.saveFormRef}
          visible={this.state.visibleFormModal}
          onCancel={this.formHandleCancel}
          onCreate={this.formHandleSubmit}
          roles={this.state.adminRoles}
          data={this.state.current_data}
          flagCreateOrUpdateForm={this.state.flagCreateOrUpdateForm}
        />
      </Layout>
		)
	}
}

const AdminForm = Form.create({name: "admin_form"})(
	class extends Component {
		componentDidUpdate = async (prevProps, prevState) => {
      const {data: pd} = prevProps
      const {data: d, form} = this.props

      if (d && d.email !== pd.email) {
      	form.setFieldsValue(d)
      }
    }

    render() {
    	const { visible, onCreate, onCancel, form, flagCreateOrUpdateForm,roles } = this.props;
      const { getFieldDecorator } = form;

      let okText = (flagCreateOrUpdateForm ? "เพิ่ม" : "แก้ไข")
      let title = okText+" ผู้ดูแลระบบ"

      return (
      	<Modal
          visible={visible}
          title={title}
          okText={okText}
          cancelText="ยกเลิก"
          onCancel={onCancel}
          onOk={onCreate}
          maskClosable={false}
          style={{ top: 20 }}
        >
          <Form layout="vertical">
            {getFieldDecorator('id')(<Input type="hidden" />)}
            <Form.Item label="ชื่อ">
            	{getFieldDecorator('firstname', {
            		rules: [{ required: true, message: "กรุณากรอกชื่อ" }],
            	})(<Input />)}
            </Form.Item>
            <Form.Item label="นามสกุล">
            	{getFieldDecorator('lastname', {
            		rules: [{ required: true, message: "กรุณากรอกนามสกุล" }],
            	})(<Input />)}
            </Form.Item>
            <Form.Item label="อีเมล">
		          {getFieldDecorator('email', {
		            rules: [
		              {
		                type: 'email',
		                message: 'กรุณากรอกอีเมลให้ถูกต้อง เช่น example@mail.com',
		              },
		              {
		                required: true,
		                message: 'กรุณากรอกอีเมล',
		              },
		            ],
		          })(<Input placeholder="เช่น example@mail.com" />)}
		        </Form.Item>
            <Form.Item label="Role">
              {getFieldDecorator('admin_role_id',{
                rules: [ {
                  required: true,
                  message: 'กรุณากรอกหน้าที่',
                }]
              })(<Select placeholder="เลือกหน้าที่">
                {roles.map(role => <Select.Option value={role.id}>
                  {role.name}
                </Select.Option>)}
              </Select>)}
            </Form.Item>
          </Form>
        </Modal>
      )
    }
	}
);

const mapStateToProps = state => {
  return {
    headerBarStore: state.headerBar
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) => dispatch(fetchMenuAction(menuParentKey, menuKey)),
    updateProfileDetailAction: ({firstname, lastname, email}) => dispatch(updateProfileDetailAction({firstname, lastname, email})),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Admin)


// WEBPACK FOOTER //
// ./src/containers/Admin/index.js